<template>
  <div class="ur-basic">
    <!-- Tab Bar -->
    <div class="ur-basic-tabbar">
      <button
        class="ur-basic-tab"
        :class="{ 'is-active': activeTab === 'landowner' }"
        @click="activeTab = 'landowner'"
      >
        {{ $t('URBANRENEWAL_ADMIN.LANDOWNER.TAB_LANDOWNER') }}
        <span class="ur-basic-tab-badge">{{ counts.landowner }}</span>
      </button>
      <button
        class="ur-basic-tab"
        :class="{ 'is-active': activeTab === 'housing' }"
        @click="activeTab = 'housing'"
      >
        {{ $t('URBANRENEWAL_ADMIN.LANDOWNER.TAB_HOUSING') }}
        <span class="ur-basic-tab-badge">{{ counts.housing }}</span>
      </button>
      <button
        class="ur-basic-tab"
        :class="{ 'is-active': activeTab === 'parking' }"
        @click="activeTab = 'parking'"
      >
        {{ $t('URBANRENEWAL_ADMIN.LANDOWNER.TAB_PARKING') }}
        <span class="ur-basic-tab-badge">{{ counts.parking }}</span>
      </button>
    </div>

    <!-- Tab Content（v-show：三個 tab 都掛載並載入，Tab 徽章才能顯示各自筆數）-->
    <div class="ur-basic-content">
      <LandownerTab
        v-show="activeTab === 'landowner'"
        :project-id="currentProjectId"
        @update:count="counts.landowner = $event"
      />
      <HousingTab
        v-show="activeTab === 'housing'"
        :project-id="currentProjectId"
        @update:count="counts.housing = $event"
      />
      <ParkingTab
        v-show="activeTab === 'parking'"
        :project-id="currentProjectId"
        @update:count="counts.parking = $event"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LandownerTab from './LandownerTab.vue';
import HousingTab from './HousingTab.vue';
import ParkingTab from './ParkingTab.vue';

export default {
  name: 'UrbanRenewalAdminBasicData',

  components: { LandownerTab, HousingTab, ParkingTab },

  data() {
    return {
      activeTab: 'landowner',
      counts: { landowner: 0, housing: 0, parking: 0 },
    };
  },

  computed: {
    ...mapState('urbanRenewalAdmin', ['currentProjectId']),
  },
};
</script>
